export const countries = [
  {
    'id': 7,
    'name': 'Австрія',
    'slug': 'austria',
  },
  {
    'id': 9,
    'name': 'Азербайджан',
    'slug': 'azerbaijan',
  },
  {
    'id': 2357,
    'name': 'Албанія',
    'slug': 'albania',
  },
  {
    'id': 6359,
    'name': 'Барбадос',
    'slug': 'barbados',
  },
  {
    'id': 18,
    'name': 'Бельгія',
    'slug': 'belgium',
  },
  {
    'id': 200,
    'name': 'Болгарія',
    'slug': 'bulgaria',
  },
  {
    'id': 2358,
    'name': 'Боснія і Герцеговина',
    'slug': 'bosniya-i-gercegovina',
  },
  {
    'id': 6329,
    'name': 'Бруней Даруссалам',
    'slug': 'brunei',
  },
  {
    'id': 21,
    'name': 'Великобританія',
    'slug': 'great-britain',
  },
  {
    'id': 13,
    'name': 'Вірменія',
    'slug': 'armenia',
  },
  {
    'id': 213,
    'name': 'Греція',
    'slug': 'greece',
  },
  {
    'id': 28,
    'name': 'Грузія',
    'slug': 'georgia',
  },
  {
    'id': 30,
    'name': 'Данія',
    'slug': 'denmark',
  },
  {
    'id': 6328,
    'name': 'Еритрея',
    'slug': 'eritrea',
  },
  {
    'id': 109,
    'name': 'Естонія',
    'slug': 'estonia',
  },
  {
    'id': 305,
    'name': 'Єгипет',
    'slug': 'egipet',
  },
  {
    'id': 6367,
    'name': 'Замбия',
    'slug': 'zambia',
  },
  {
    'id': 33,
    'name': 'Ізраїль',
    'slug': 'israel',
  },
  {
    'id': 36,
    'name': 'Ірландія',
    'slug': 'ireland',
  },
  {
    'id': 302,
    'name': 'Ісландія',
    'slug': 'iceland',
  },
  {
    'id': 37,
    'name': 'Іспанія',
    'slug': 'spain',
  },
  {
    'id': 38,
    'name': 'Італія',
    'slug': 'italy',
  },
  {
    'id': 40,
    'name': 'Казахстан',
    'slug': 'kazakhstan',
  },
  {
    'id': 45,
    'name': 'Канада',
    'slug': 'canada',
  },
  {
    'id': 48,
    'name': 'Киргизстан',
    'slug': 'kyrgyzstan',
  },
  {
    'id': 50,
    'name': 'Китай',
    'slug': 'china',
  },
  {
    'id': 236,
    'name': 'Кіпр',
    'slug': 'cyprus',
  },
  {
    'id': 6948,
    'name': 'Косово',
    'slug': 'kosovo',
  },
  {
    'id': 6323,
    'name': 'Лаос',
    'slug': 'laos',
  },
  {
    'id': 57,
    'name': 'Латвія',
    'slug': 'latvia',
  },
  {
    'id': 59,
    'name': 'Литва',
    'slug': 'lithuania',
  },
  {
    'id': 2355,
    'name': 'Ліхтенштейн',
    'slug': 'liechtenstein',
  },
  {
    'id': 206,
    'name': 'Люксембург',
    'slug': 'luxembourg',
  },
  {
    'id': 2359,
    'name': 'Македонія',
    'slug': 'macedonia',
  },
  {
    'id': 2353,
    'name': 'Мальта',
    'slug': 'malta',
  },
  {
    'id': 2229,
    'name': 'Мексика',
    'slug': 'mexico',
  },
  {
    'id': 62,
    'name': 'Молдова',
    'slug': 'moldova',
  },
  {
    'id': 2356,
    'name': 'Монако',
    'slug': 'monaco',
  },
  {
    'id': 2231,
    'name': 'Монголія',
    'slug': 'mongolia',
  },
  {
    'id': 65,
    'name': 'Нiдерланди',
    'slug': 'netherlands',
  },
  {
    'id': 6326,
    'name': 'Непал',
    'slug': 'nepal',
  },
  {
    'id': 27,
    'name': 'Німеччина',
    'slug': 'germany',
  },
  {
    'id': 207,
    'name': 'Норвегія',
    'slug': 'norway',
  },
  {
    'id': 208,
    'name': 'ОАЕ',
    'slug': 'uae',
  },
  {
    'id': 6058,
    'name': 'Об\'єднана Республіка Танзанія',
    'slug': 'united-republic-of-tanzania',
  },
  {
    'id': 211,
    'name': 'ПАР',
    'slug': 'south-africa',
  },
  {
    'id': 6327,
    'name': 'Парагвай',
    'slug': 'paraguay',
  },
  {
    'id': 74,
    'name': 'Польща',
    'slug': 'poland',
  },
  {
    'id': 241,
    'name': 'Португалія',
    'slug': 'portugal',
  },
  {
    'id': 6377,
    'name': 'Республіка Гаїті',
    'slug': 'haiti-republic',
  },
  {
    'id': 6356,
    'name': 'Республіка Ель-Сальвадор',
    'slug': 'republic-of-el-salvador',
  },
  {
    'id': 6337,
    'name': 'Республіка Малаві',
    'slug': 'malawi',
  },
  {
    'id': 6350,
    'name': 'Республіка Чад',
    'slug': 'republic-of-chad',
  },
  {
    'id': 234,
    'name': 'Румунія',
    'slug': 'romania',
  },
  {
    'id': 6962,
    'name': 'Сан-Марино',
    'slug': 'san-marino',
  },
  {
    'id': 146,
    'name': 'Сербія',
    'slug': 'serbia',
  },
  {
    'id': 318,
    'name': 'Словаччина',
    'slug': 'slovakiya',
  },
  {
    'id': 2105,
    'name': 'Словенія',
    'slug': 'slovenia',
  },
  {
    'id': 85,
    'name': 'США',
    'slug': 'usa',
  },
  {
    'id': 86,
    'name': 'Таджикистан',
    'slug': 'tajikistan',
  },
  {
    'id': 6330,
    'name': 'Тоголезська Республіка',
    'slug': 'togo',
  },
  {
    'id': 94,
    'name': 'Туреччина',
    'slug': 'turkey',
  },
  {
    'id': 93,
    'name': 'Туркменістан',
    'slug': 'turkmenistan',
  },
  {
    'id': 114,
    'name': 'Угорщина',
    'slug': 'hungary',
  },
  {
    'id': 97,
    'name': 'Узбекистан',
    'slug': 'uzbekistan',
  },
  {
    'id': 5,
    'name': 'Україна',
    'slug': 'ukraine',
  },
  {
    'id': 100,
    'name': 'Фінляндія',
    'slug': 'finland',
  },
  {
    'id': 101,
    'name': 'Франція',
    'slug': 'france',
  },
  {
    'id': 2103,
    'name': 'Хорватія',
    'slug': 'croatia',
  },
  {
    'id': 6448,
    'name': 'Центральноафриканська Республіка',
    'slug': 'central-afrikan-republic',
  },
  {
    'id': 199,
    'name': 'Чехія',
    'slug': 'czech-republic',
  },
  {
    'id': 5046,
    'name': 'Чорногорія',
    'slug': 'montenegro',
  },
  {
    'id': 108,
    'name': 'Швейцарія',
    'slug': 'switzerland',
  },
  {
    'id': 149,
    'name': 'Швеція',
    'slug': 'sweden',
  },
];

export const categories = [
  {
    'id': 7,
    'name': 'Автомобільний бізнес',
    'slug': 'automotive-business',
  },
  {
    'id': 4,
    'name': 'Адміністративний персонал',
    'slug': 'administrative-personnel',
  },
  {
    'id': 5,
    'name': 'Банки, інвестиції, лізинг',
    'slug': 'banks-investments-finance',
  },
  {
    'id': 8,
    'name': 'Безпека',
    'slug': 'security',
  },
  {
    'id': 20,
    'name': 'Будівництво, нерухомість',
    'slug': 'construction-real-estate',
  },
  {
    'id': 2,
    'name': 'Бухгалтерія, управлінський облік, фінанси підприємства',
    'slug': 'accounting-management-accounting-corporate-finance',
  },
  {
    'id': 10,
    'name': 'Видобуток сировини',
    'slug': 'raw-materials',
  },
  {
    'id': 18,
    'name': 'Виробництво, сільське господарство',
    'slug': 'manufacturing-agriculture',
  },
  {
    'id': 9,
    'name': 'Вищий менеджмент',
    'slug': 'management',
  },
  {
    'id': 16,
    'name': 'Державна служба, некомерційні організації',
    'slug': 'government-ngos',
  },
  {
    'id': 27,
    'name': 'Домашній персонал',
    'slug': 'domestic-staff',
  },
  {
    'id': 26,
    'name': 'Закупівлі',
    'slug': 'procurement',
  },
  {
    'id': 25,
    'name': 'Інсталяція і сервіс',
    'slug': 'installation-and-service',
  },
  {
    'id': 1,
    'name': 'Інформаційні технології, інтернет, телеком',
    'slug': 'it-internet-telecom',
  },
  {
    'id': 12,
    'name': 'Консультування',
    'slug': 'consulting',
  },
  {
    'id': 3,
    'name': 'Маркетинг, реклама, PR',
    'slug': 'marketing-advertising-pr',
  },
  {
    'id': 13,
    'name': 'Медицина, фармацевтика',
    'slug': 'medicine-pharmaceuticals',
  },
  {
    'id': 11,
    'name': 'Мистецтво, розваги, мас-медіа',
    'slug': 'art-entertainment-media',
  },
  {
    'id': 14,
    'name': 'Наука, освіта',
    'slug': 'science-education',
  },
  {
    'id': 15,
    'name': 'Початок кар\'єри, студенти',
    'slug': 'career-starters-students',
  },
  {
    'id': 17,
    'name': 'Продажі',
    'slug': 'sales',
  },
  {
    'id': 29,
    'name': 'Робітничий персонал',
    'slug': 'maintenance-and-operations-personnel',
  },
  {
    'id': 24,
    'name': 'Спортивні клуби, фітнес, салони краси',
    'slug': 'sports-clubs-fitness-clubs-beauty-salons',
  },
  {
    'id': 19,
    'name': 'Страхування',
    'slug': 'insurance',
  },
  {
    'id': 21,
    'name': 'Транспорт, логістика',
    'slug': 'transport-logistics',
  },
  {
    'id': 22,
    'name': 'Туризм, готелі, ресторани',
    'slug': 'tourism-hotels-restaurants',
  },
  {
    'id': 6,
    'name': 'Управління персоналом, тренінги',
    'slug': 'human-resources-training',
  },
  {
    'id': 23,
    'name': 'Юристи',
    'slug': 'lawyers',
  },
];

export const currencies = {
  '1': '₴ (грн.)',
  '2': '$ (dollar)',
  '3': '€ (euro)',
};

export const industries = [
  {
    'id': 461,
    'name': 'Авіаперевезення',
    'slug': 'air-cargo',
  },
  {
    'id': 428,
    'name': 'Авіаційна, гелікоптерна, аерокосмічна промисловість',
    'slug': 'aviation-helicopter-airspace-industry',
  },
  {
    'id': 547,
    'name': 'Автозапчастини, шини (роздрібна торгівля)',
    'slug': 'auto-parts-tires-retail',
  },
  {
    'id': 545,
    'name': 'Автокомпоненти, запчастини (виробництво)',
    'slug': 'auto-parts-and-components-manufacturing',
  },
  {
    'id': 546,
    'name': 'Автокомпоненти, запчастини, шини (просування, оптова торгівля)',
    'slug': 'auto-components-parts-tires-promotion-wholesale',
  },
  {
    'id': 15,
    'name': 'Автомобільний бізнес',
    'slug': 'automotive-business',
  },
  {
    'id': 462,
    'name': 'Автомобільні перевезення',
    'slug': 'freight-transport',
  },
  {
    'id': 447,
    'name': 'Автошкола',
    'slug': 'driving-school',
  },
  {
    'id': 416,
    'name': 'Агрохімія (виробництво)',
    'slug': 'agrochemistry-production',
  },
  {
    'id': 417,
    'name': 'Агрохімія (просування, оптова торгівля)',
    'slug': 'agrochemistry-promotion-wholesale',
  },
  {
    'id': 16,
    'name': 'Алкоголь / тютюнова продукція',
    'slug': 'alcohol-tobacco-products',
  },
  {
    'id': 555,
    'name': 'Алкогольні напої (просування, оптова торгівля)',
    'slug': 'alcoholic-drinks-promotion-wholesale',
  },
  {
    'id': 472,
    'name': 'Альтернативна енергетика: гео-, вітро, сонце-, біо (генерація електроенергії)',
    'slug': 'alternative-energy-geo-wind-solar-bio-power-generation',
  },
  {
    'id': 676,
    'name': 'Аптека, оптика',
    'slug': 'pharmacy-optician',
  },
  {
    'id': 651,
    'name': 'Архів, бібліотека, мистецтвознавство',
    'slug': 'archive-library-art-history',
  },
  {
    'id': 663,
    'name': 'Архітектура, проектування',
    'slug': 'architecture-design',
  },
  {
    'id': 626,
    'name': 'Асоціація в сфері культури, мистецтва',
    'slug': 'culture-or-art-association',
  },
  {
    'id': 469,
    'name': 'Атомна енергетика (генерація електроенергії, АЕС)',
    'slug': 'nuclear-power-power-generation-npp',
  },
  {
    'id': 641,
    'name': 'Аудит, управлінський облік, фінансово-юридичний консалтинг',
    'slug': 'auditing-management-accounting-financial-and-legal-consulting',
  },
  {
    'id': 40,
    'name': 'Багатопрофільний холдинг',
    'slug': 'diversified-holding',
  },
  {
    'id': 647,
    'name': 'Банк',
    'slug': 'banking',
  },
  {
    'id': 1,
    'name': 'Банки / кредити / інвестиції / лізинг',
    'slug': 'banks-credit-investments-finance',
  },
  {
    'id': 550,
    'name': 'Безалкогольні напої (виробництво)',
    'slug': 'non-alcoholic-beverages-production',
  },
  {
    'id': 551,
    'name': 'Безалкогольні напої (просування, оптова торгівля)',
    'slug': 'non-alcoholic-beverages-promotion-wholesale',
  },
  {
    'id': 17,
    'name': 'Безпека / охоронна діяльність',
    'slug': 'safety-security',
  },
  {
    'id': 390,
    'name': 'Безпека, охоронна діяльність',
    'slug': 'safety-security',
  },
  {
    'id': 418,
    'name': 'Бетон, цегла, скло та інші силікати (виробництво)',
    'slug': 'concrete-brick-glass-and-other-silicates-manufacturing',
  },
  {
    'id': 419,
    'name': 'Бетон, цегла, скло та інші силікати (просування, оптова торгівля)',
    'slug': 'concrete-brick-glass-and-other-silicates-promotion-wholesale',
  },
  {
    'id': 444,
    'name': 'Бізнес-освіта',
    'slug': 'business-education',
  },
  {
    'id': 627,
    'name': 'Благодійна організація',
    'slug': 'charitable-organization',
  },
  {
    'id': 671,
    'name': 'Благоустрій та прибирання територій і будівель',
    'slug': 'landscaping-cleaning-of-buildings-and-outdoor-areas',
  },
  {
    'id': 570,
    'name': 'Борошно, крупи (виробництво)',
    'slug': 'flour-cereals-production',
  },
  {
    'id': 571,
    'name': 'Борошно, крупи (просування, оптова торгівля)',
    'slug': 'flour-cereals-promotion-wholesale',
  },
  {
    'id': 652,
    'name': 'Ботанічний сад, зоопарк, заповідник',
    'slug': 'botanical-garden-zoo-reserve',
  },
  {
    'id': 508,
    'name': 'Будівельна техніка, устаткування, ліфти, вантажно-розвантажувальне, складське обладнання (виробництво)',
    'slug': 'construction-machines-equipment-elevators-loading-warehouse-equipment-manufacturing',
  },
  {
    'id': 509,
    'name': 'Будівельна техніка, устаткування, ліфти, вантажно-розвантажувальне, складське обладнання (монтаж, сервіс, ремонт)',
    'slug': 'construction-machines-equipment-elevators-loading-warehouse-equipment-assembly-maintenance-repair',
  },
  {
    'id': 510,
    'name': 'Будівельна техніка, устаткування, ліфти, вантажно-розвантажувальне, складське обладнання (просування, оптова торгівля)',
    'slug': 'construction-machines-equipment-elevators-loading-warehouse-equipment-promotion-wholesale',
  },
  {
    'id': 662,
    'name': 'Будівництво дорожнє й інфраструктурне',
    'slug': 'road-and-infrastructure-construction',
  },
  {
    'id': 658,
    'name': 'Будівництво енергетичне',
    'slug': 'energy-construction',
  },
  {
    'id': 661,
    'name': 'Будівництво житлове',
    'slug': 'housing-construction',
  },
  {
    'id': 660,
    'name': 'Будівництво комерційних об\'єктів (торгові площі, офісні будівлі)',
    'slug': 'commercial-property-construction-retail-spaces-office-buildings',
  },
  {
    'id': 656,
    'name': 'Будівництво об\'єктів металургійної галузі',
    'slug': 'construction-of-metallurgy-industry-facilities',
  },
  {
    'id': 655,
    'name': 'Будівництво об\'єктів нафтогазової галузі',
    'slug': 'construction-of-oil-and-gas-industry-facilities',
  },
  {
    'id': 657,
    'name': 'Будівництво об\'єктів телекомунікаційної галузі',
    'slug': 'construction-of-telecommunication-industry-facilities',
  },
  {
    'id': 659,
    'name': 'Будівництво промислове',
    'slug': 'industrial-construction',
  },
  {
    'id': 13,
    'name': 'Будівництво, нерухомість, архітектура',
    'slug': 'construction-real-estate-architecture',
  },
  {
    'id': 14,
    'name': 'Будматеріали',
    'slug': 'construction-materials',
  },
  {
    'id': 600,
    'name': 'Будматеріали, збірні конструкції для ремонту та будівництва (виробництво, монтаж, сервіс, ремонт)',
    'slug': 'prefabricated-structures-for-repair-and-construction-work-assembly-maintenance-repair',
  },
  {
    'id': 599,
    'name': 'Будматеріали, збірні конструкції для ремонту та будівництва (просування, оптова торгівля)',
    'slug': 'prefabricated-structures-for-repair-and-construction-work-promotion-wholesale',
  },
  {
    'id': 523,
    'name': 'Вендінг (торгівля через автомати)',
    'slug': 'vending-trade-through-vending-machines',
  },
  {
    'id': 667,
    'name': 'Вентиляція та кондиціонування (монтаж, сервіс, ремонт)',
    'slug': 'ventilation-and-air-conditioning-assembly-maintenance-repair',
  },
  {
    'id': 677,
    'name': 'Ветеринарна аптека',
    'slug': 'veterinary-pharmacy',
  },
  {
    'id': 678,
    'name': 'Ветеринарна діяльність',
    'slug': 'veterinary-medicine',
  },
  {
    'id': 448,
    'name': 'Вивчення іноземних мов',
    'slug': 'teaching-foreign-languages',
  },
  {
    'id': 449,
    'name': 'Вивчення мистецтв (малювання, спів, танці, фото)',
    'slug': 'teaching-arts-drawing-singing-dancing-photography',
  },
  {
    'id': 452,
    'name': 'Видавнича справа',
    'slug': 'publishing',
  },
  {
    'id': 45,
    'name': 'Видобувна галузь',
    'slug': 'mining-industry',
  },
  {
    'id': 20,
    'name': 'Видобувна галузь / енергетика / ПММ',
    'slug': 'raw-materials-power-fuels-and-lubricants',
  },
  {
    'id': 617,
    'name': 'Видобуток газу',
    'slug': 'gas-extraction',
  },
  {
    'id': 534,
    'name': 'Видобуток і збагачення вугілля',
    'slug': 'coal-mining-and-processing',
  },
  {
    'id': 536,
    'name': 'Видобуток і збагачення мінеральної сировини (сіль, сірка, глинозем), розробка кар\'єрів (пісок, глина, камінь), видобуток торфу',
    'slug': 'mining-and-processing-of-mineral-raw-materials-salt-sulfur-alumina-quarry-development-sand-clay-stone-peat-digging',
  },
  {
    'id': 535,
    'name': 'Видобуток і збагачення руд чорних, кольорових, дорогоцінних, благородних, рідкісних металів',
    'slug': 'mining-and-processing-of-ferrous-non-ferrous-precious-noble-rare-metal-ores',
  },
  {
    'id': 611,
    'name': 'Видобуток нафти',
    'slug': 'oil-extraction',
  },
  {
    'id': 552,
    'name': 'Вино (виробництво)',
    'slug': 'wine-production',
  },
  {
    'id': 460,
    'name': 'Виробництво друкованої, поліграфічної продукції',
    'slug': 'production-of-print-material',
  },
  {
    'id': 685,
    'name': 'Виробництво і продаж рекламно-сувенірної продукції',
    'slug': 'production-and-sale-of-promotional-merchandise',
  },
  {
    'id': 440,
    'name': 'Виробництво й ремонт військової техніки, обладнання та озброєння',
    'slug': 'manufacturing-and-repair-of-military-machinery-equipment-and-weaponry',
  },
  {
    'id': 453,
    'name': 'Виробництво мультимедіа, контенту, редакторська діяльність',
    'slug': 'production-of-multimedia-and-content-editing',
  },
  {
    'id': 28,
    'name': 'Витратні матеріали / канцтовари',
    'slug': 'consumables-office-supplies',
  },
  {
    'id': 668,
    'name': 'Водопостачання та каналізація',
    'slug': 'water-and-wastewater-systems',
  },
  {
    'id': 442,
    'name': 'Вуз, ссуз коледж, ПТУ',
    'slug': 'higher-education-institution-secondary-specialized-college-college-vocational-school',
  },
  {
    'id': 470,
    'name': 'Гідроенергетика (генерація електроенергії, ГЕС)',
    'slug': 'hydroelectric-engineering-power-generation-hep',
  },
  {
    'id': 50,
    'name': 'Готелі, ресторани, громадське харчування, кейтеринг',
    'slug': 'hotels-restaurants-food-service-industry-catering',
  },
  {
    'id': 527,
    'name': 'Готель',
    'slug': 'hotel',
  },
  {
    'id': 406,
    'name': 'Гральний бізнес',
    'slug': 'gambling',
  },
  {
    'id': 37,
    'name': 'Громадська діяльність, партії, благодійність, НКО',
    'slug': 'public-activity-political-parties-volunteering-non-profit-organizations',
  },
  {
    'id': 628,
    'name': 'Громадська, політична організація',
    'slug': 'civic-political-organization',
  },
  {
    'id': 426,
    'name': 'Гума, пластмаса та інше (виробництво)',
    'slug': 'rubber-plastic-etc-manufacturing',
  },
  {
    'id': 427,
    'name': 'Гума, пластмаса та інше (просування, оптова торгівля)',
    'slug': 'rubber-plastic-etc-promotion-wholesale',
  },
  {
    'id': 431,
    'name': 'Двигуни (виробництво)',
    'slug': 'engines-manufacturing',
  },
  {
    'id': 432,
    'name': 'Двигуни (монтаж, сервіс, ремонт)',
    'slug': 'engines-assembly-maintenance-repair',
  },
  {
    'id': 433,
    'name': 'Двигуни (просування, оптова торгівля)',
    'slug': 'engines-promotion-wholesale',
  },
  {
    'id': 654,
    'name': 'Девелопмент',
    'slug': 'development',
  },
  {
    'id': 620,
    'name': 'Деревообробка (виробництво)',
    'slug': 'timber-industry-production',
  },
  {
    'id': 36,
    'name': 'Державні організації',
    'slug': 'government-organizations',
  },
  {
    'id': 403,
    'name': 'Державні організації',
    'slug': 'governmental-organizations',
  },
  {
    'id': 12,
    'name': 'Дизайн / мультимедіа / поліграфія',
    'slug': 'design-multimedia-printing',
  },
  {
    'id': 556,
    'name': 'Дитяче харчування (виробництво)',
    'slug': 'baby-food-production',
  },
  {
    'id': 557,
    'name': 'Дитяче харчування (просування, оптова торгівля)',
    'slug': 'baby-food-promotion-wholesale',
  },
  {
    'id': 405,
    'name': 'Домашній персонал',
    'slug': 'domestic-staff',
  },
  {
    'id': 637,
    'name': 'Дорогоцінні, благородні та рідкісні метали (виробництво)',
    'slug': 'precious-noble-and-rare-metals-production',
  },
  {
    'id': 638,
    'name': 'Дорогоцінні, благородні та рідкісні метали (просування, оптова торгівля)',
    'slug': 'precious-noble-and-rare-metals-promotion-wholesale',
  },
  {
    'id': 395,
    'name': 'Екологічне обслуговування, водоочищення, утилізація відходів',
    'slug': 'environmental-maintenance-water-purification-waste-recycling',
  },
  {
    'id': 8,
    'name': 'Електроніка, приладобудування, побутова техніка, комп\'ютери та оргтехніка',
    'slug': 'electronics-tool-engineering-household-appliances-computers-and-office-equipment',
  },
  {
    'id': 484,
    'name': 'Електронно-обчислювальна, оптична, контрольно-вимірювальна техніка, радіоелектроніка, автоматика (виробництво)',
    'slug': 'computer-optical-control-and-measurement-technology-radio-and-electronics-automatics-manufacturing',
  },
  {
    'id': 485,
    'name': 'Електронно-обчислювальна, оптична, контрольно-вимірювальна техніка, радіоелектроніка, автоматика (монтаж, сервіс, ремонт)',
    'slug': 'computer-optical-control-and-measurement-technology-radio-and-electronics-automatics-assembly-maintenance-repair',
  },
  {
    'id': 486,
    'name': 'Електронно-обчислювальна, оптична, контрольно-вимірювальна техніка, радіоелектроніка, автоматика (просування, оптова торгівля)',
    'slug': 'computer-optical-control-and-measurement-technology-radio-and-electronics-automatics-promotion-wholesale',
  },
  {
    'id': 46,
    'name': 'Енергетика',
    'slug': 'power-industry',
  },
  {
    'id': 675,
    'name': 'Енергопостачання',
    'slug': 'electric-power-supply',
  },
  {
    'id': 51,
    'name': 'ЖКГ',
    'slug': 'utilities',
  },
  {
    'id': 670,
    'name': 'Забезпечення пожежної безпеки, захисту від блискавок',
    'slug': 'fire-protection-lightning-protection',
  },
  {
    'id': 434,
    'name': 'Залізничне машинобудування, вагонобудування',
    'slug': 'railway-engineering-car-building',
  },
  {
    'id': 463,
    'name': 'Залізничні перевезення',
    'slug': 'rail-transportation',
  },
  {
    'id': 474,
    'name': 'Збут і споживання електроенергії',
    'slug': 'sale-and-consumption-of-power',
  },
  {
    'id': 468,
    'name': 'ЗЕД, митне оформлення',
    'slug': 'international-logistics-customs-clearance',
  },
  {
    'id': 531,
    'name': 'Землеробство, рослинництво, тваринництво',
    'slug': 'agriculture-crop-production-livestock-breeding',
  },
  {
    'id': 11,
    'name': 'ЗМІ, маркетинг, реклама, PR, дизайн, продюсування',
    'slug': 'media-marketing-advertising-pr-design-production',
  },
  {
    'id': 524,
    'name': 'Зоомагазин',
    'slug': 'pet-store',
  },
  {
    'id': 537,
    'name': 'Інженерно-вишукувальні, гідрогеологічні, геологорозвідувальні роботи',
    'slug': 'engineering-and-surveying-hydrogeological-geological-exploration-works',
  },
  {
    'id': 451,
    'name': 'Інтернат, дитячий будинок',
    'slug': 'boarding-school-orphanage',
  },
  {
    'id': 541,
    'name': 'Інтернет-компанія (пошуковики, платіжні системи, соц.мережі, інформаційно-пізнавальні та розважальні ресурси, просування сайтів тощо)',
    'slug': 'internet-company-search-engines-payment-systems-social-networks-information-and-educational-entertainment-resources-website-promotion-etc',
  },
  {
    'id': 525,
    'name': 'Інтернет-магазин',
    'slug': 'internet-store',
  },
  {
    'id': 538,
    'name': 'Інтернет-провайдер',
    'slug': 'internet-service-provider',
  },
  {
    'id': 7,
    'name': 'Інформаційні технології, системна інтеграція, інтернет',
    'slug': 'it-system-integration-internet',
  },
  {
    'id': 476,
    'name': 'Інфраструктурна компанія в енергетиці (СО ЄЕС, АТС, ЦФР тощо)',
    'slug': 'infrastructural-company-in-the-energy-sector-system-operator-of-the-unified-power-system-trading-grid-administrator-financial-arrangements-center-etc', // eslint-disable-line
  },
  {
    'id': 391,
    'name': 'Кадрові агенції',
    'slug': 'recruitment-agencies',
  },
  {
    'id': 591,
    'name': 'Канцтовари, витратні матеріали (виробництво)',
    'slug': 'office-supplies-consumables-manufacturing',
  },
  {
    'id': 592,
    'name': 'Канцтовари, витратні матеріали (просування, оптова торгівля)',
    'slug': 'office-supplies-consumables-promotion-wholesale',
  },
  {
    'id': 529,
    'name': 'Кейтеринг (виїзне обслуговування)',
    'slug': 'catering-outside-food-services',
  },
  {
    'id': 530,
    'name': 'Керуюча компанія групи, холдингу, штаб-квартира',
    'slug': 'management-holding-company-headquarters',
  },
  {
    'id': 648,
    'name': 'Керуюча, інвестиційна компанія (управління активами)',
    'slug': 'managing-investment-company-asset-management',
  },
  {
    'id': 455,
    'name': 'Кіностудії та студії звукозапису',
    'slug': 'film-production-and-audio-recording-studios',
  },
  {
    'id': 679,
    'name': 'Клінічні дослідження',
    'slug': 'clinical-research',
  },
  {
    'id': 643,
    'name': 'Колекторська діяльність',
    'slug': 'debt-collection',
  },
  {
    'id': 392,
    'name': 'Колл-центри, диспетчерські служби',
    'slug': 'call-centers-operations-control-services',
  },
  {
    'id': 635,
    'name': 'Кольорова металургія (виплавка, металопрокат)',
    'slug': 'non-ferrous-metallurgy-smelt-rolled-metal',
  },
  {
    'id': 558,
    'name': 'Кондитерські вироби (виробництво)',
    'slug': 'confectionery-products-production',
  },
  {
    'id': 559,
    'name': 'Кондитерські вироби (просування, оптова торгівля)',
    'slug': 'confectionery-products-promotion-wholesale',
  },
  {
    'id': 2,
    'name': 'Консалтинг / аудит / сертифікація',
    'slug': 'consulting-auditing-certification',
  },
  {
    'id': 477,
    'name': 'Консалтинг у сфері енергоефективності',
    'slug': 'consulting-in-energy-efficiency',
  },
  {
    'id': 665,
    'name': 'Консалтинг, оцінювання в нерухомості',
    'slug': 'consulting-real-estate-valuation',
  },
  {
    'id': 393,
    'name': 'Консалтингові послуги',
    'slug': 'consulting-services',
  },
  {
    'id': 560,
    'name': 'Консервована продукція (виробництво)',
    'slug': 'canned-products-production',
  },
  {
    'id': 561,
    'name': 'Консервована продукція (просування, оптова торгівля)',
    'slug': 'canned-products-promotion-wholesale',
  },
  {
    'id': 397,
    'name': 'Контроль якості, експертиза, випробування й сертифікація',
    'slug': 'quality-control-assessment-testing-and-certification',
  },
  {
    'id': 562,
    'name': 'Корм для тварин (виробництво)',
    'slug': 'pet-food-production',
  },
  {
    'id': 563,
    'name': 'Корм для тварин (просування, оптова торгівля)',
    'slug': 'pet-food-promotion-wholesale',
  },
  {
    'id': 21,
    'name': 'Косметика / парфумерія / побутова хімія',
    'slug': 'cosmetics-perfumery-household-cleaning-products',
  },
  {
    'id': 467,
    'name': 'Кур\'єрська, поштова доставка',
    'slug': 'courier-mail-delivery',
  },
  {
    'id': 680,
    'name': 'Лабораторія, дослідницький центр',
    'slug': 'laboratory-research-center',
  },
  {
    'id': 420,
    'name': 'Лакофарбова продукція, сировина (виробництво)',
    'slug': 'paint-and-varnish-products-raw-materials-manufacturing',
  },
  {
    'id': 421,
    'name': 'Лакофарбова продукція, сировина (просування, оптова торгівля)',
    'slug': 'paint-and-varnish-products-raw-materials-promotion-wholesale',
  },
  {
    'id': 542,
    'name': 'Легкові, вантажні автомобілі, мототехніка, автобуси, тролейбуси (виробництво)',
    'slug': 'cars-trucks-motor-transport-buses-trolleybuses-manufacturing',
  },
  {
    'id': 543,
    'name': 'Легкові, вантажні автомобілі, мототехніка, автобуси, тролейбуси (просування, оптова торгівля)',
    'slug': 'cars-trucks-motor-transport-buses-trolleybuses-promotion-wholesale',
  },
  {
    'id': 644,
    'name': 'Лізингові компанії',
    'slug': 'leasing-companies',
  },
  {
    'id': 553,
    'name': 'Лікеро-горілчана продукція (виробництво)',
    'slug': 'liqueurs-and-spirits-production',
  },
  {
    'id': 681,
    'name': 'Лікувально-профілактичні установи',
    'slug': 'medical-institutions',
  },
  {
    'id': 19,
    'name': 'Лісова промисловість, деревообробка',
    'slug': 'timber-industry',
  },
  {
    'id': 669,
    'name': 'Ліфтове господарство (монтаж, сервіс, ремонт)',
    'slug': 'elevator-facilities-assembly-maintenance-repair',
  },
  {
    'id': 573,
    'name': 'М\'ясна продукція (виробництво)',
    'slug': 'meat-products-production',
  },
  {
    'id': 572,
    'name': 'М\'ясна продукція (просування, оптова торгівля)',
    'slug': 'meat-products-promotion-wholesale',
  },
  {
    'id': 564,
    'name': 'Макаронні вироби (виробництво)',
    'slug': 'pasta-production',
  },
  {
    'id': 565,
    'name': 'Макаронні вироби (просування, оптова торгівля)',
    'slug': 'pasta-promotion-wholesale',
  },
  {
    'id': 10,
    'name': 'Маркетинг / реклама / PR',
    'slug': 'marketing-advertising-pr',
  },
  {
    'id': 566,
    'name': 'Масло-жирова продукція (виробництво)',
    'slug': 'fat-and-oil-products-production',
  },
  {
    'id': 567,
    'name': 'Масло-жирова продукція (просування, оптова торгівля)',
    'slug': 'fat-and-oil-products-promotion-wholesale',
  },
  {
    'id': 593,
    'name': 'Меблі (виробництво)',
    'slug': 'furniture-manufacturing',
  },
  {
    'id': 594,
    'name': 'Меблі (просування, оптова торгівля)',
    'slug': 'furniture-promotion-wholesale',
  },
  {
    'id': 22,
    'name': 'Меблі / сантехніка',
    'slug': 'furniture-plumbing',
  },
  {
    'id': 23,
    'name': 'Медицина / фармацевтика',
    'slug': 'medicine-pharmaceuticals',
  },
  {
    'id': 48,
    'name': 'Медицина, фармацевтика, аптеки',
    'slug': 'medicine-pharmaceuticals-pharmacies',
  },
  {
    'id': 487,
    'name': 'Медичне, діагностичне обладнання, інструменти (виробництво)',
    'slug': 'medical-diagnostic-equipment-tools-manufacturing',
  },
  {
    'id': 488,
    'name': 'Медичне, діагностичне обладнання, інструменти (монтаж, сервіс, ремонт)',
    'slug': 'medical-diagnostic-equipment-tools-assembly-maintenance-repair',
  },
  {
    'id': 489,
    'name': 'Медичне, діагностичне обладнання, інструменти (просування, оптова торгівля)',
    'slug': 'medical-diagnostic-equipment-tools-promotion-wholesale',
  },
  {
    'id': 639,
    'name': 'Металеві вироби, металоконструкції (виробництво)',
    'slug': 'metalware-metal-structures-manufacturing',
  },
  {
    'id': 640,
    'name': 'Металеві вироби, металоконструкції (просування, оптова торгівля)',
    'slug': 'metalware-metal-structures-promotion-wholesale',
  },
  {
    'id': 24,
    'name': 'Металургія, металообробка',
    'slug': 'metallurgy-metalwork',
  },
  {
    'id': 52,
    'name': 'Мистецтво, культура',
    'slug': 'art-culture',
  },
  {
    'id': 399,
    'name': 'Мобільний зв\'язок',
    'slug': 'mobile-communications',
  },
  {
    'id': 568,
    'name': 'Молочна продукція (виробництво)',
    'slug': 'dairy-products-production',
  },
  {
    'id': 569,
    'name': 'Молочна продукція (просування, оптова торгівля)',
    'slug': 'dairy-products-promotion-wholesale',
  },
  {
    'id': 464,
    'name': 'Морські, річкові перевезення',
    'slug': 'sea-river-transportation',
  },
  {
    'id': 653,
    'name': 'Музей, галерея, театр',
    'slug': 'museum-gallery-theater',
  },
  {
    'id': 578,
    'name': 'Напівфабрикати, зокрема заморожені (виробництво)',
    'slug': 'semi-processed-foods-including-frozen-foods-manufacturing',
  },
  {
    'id': 579,
    'name': 'Напівфабрикати, зокрема заморожені (просування, оптова торгівля)',
    'slug': 'semi-processed-foods-including-frozen-foods-promotion-wholesale',
  },
  {
    'id': 441,
    'name': 'Науково-дослідна, наукова, академічна діяльність',
    'slug': 'research-scientific-academic-activity',
  },
  {
    'id': 47,
    'name': 'Нафта і газ',
    'slug': 'oil-and-gas',
  },
  {
    'id': 612,
    'name': 'Нафтопереробка, нафтохімія (виробництво)',
    'slug': 'oil-refining-petrochemistry-production',
  },
  {
    'id': 614,
    'name': 'Нафтохімія (просування, оптова торгівля)',
    'slug': 'petrochemistry-promotion-wholesale',
  },
  {
    'id': 526,
    'name': 'Немережевий роздріб, дрібний опт',
    'slug': 'non-chain-retail-small-wholesale',
  },
  {
    'id': 422,
    'name': 'Неорганічна хімія (виробництво)',
    'slug': 'inorganic-chemistry-manufacturing',
  },
  {
    'id': 423,
    'name': 'Неорганічна хімія (просування, оптова торгівля)',
    'slug': 'inorganic-chemistry-promotion-wholesale',
  },
  {
    'id': 645,
    'name': 'НПФ',
    'slug': 'non-governmental-pension-fund',
  },
  {
    'id': 25,
    'name': 'Одяг / взуття / текстиль',
    'slug': 'clothing-footwear-textiles',
  },
  {
    'id': 595,
    'name': 'Одяг, взуття, аксесуари, текстиль (виробництво)',
    'slug': 'clothing-footwear-accessories-textiles-manufacturing',
  },
  {
    'id': 596,
    'name': 'Одяг, взуття, аксесуари, текстиль (просування, оптова торгівля)',
    'slug': 'clothing-footwear-accessories-textiles-promotion-wholesale',
  },
  {
    'id': 401,
    'name': 'Оптоволоконний зв\'язок',
    'slug': 'fiber-optic-communications',
  },
  {
    'id': 459,
    'name': 'Організація виставок, Event-, PR, рекламні, дизайн- послуги',
    'slug': 'marketing-advertising-designer-event-and-pr-agencies',
  },
  {
    'id': 424,
    'name': 'Органічна хімія (виробництво)',
    'slug': 'organic-chemistry-manufacturing',
  },
  {
    'id': 425,
    'name': 'Органічна хімія (просування, оптова торгівля)',
    'slug': 'organic-chemistry-promotion-wholesale',
  },
  {
    'id': 404,
    'name': 'Оренда автомобілів',
    'slug': 'car-hire',
  },
  {
    'id': 39,
    'name': 'Освітні установи',
    'slug': 'educational-institutions',
  },
  {
    'id': 5,
    'name': 'Перевезення, логістика, склад, ЗЕД',
    'slug': 'transportation-logistics-warehousing-international-logistics',
  },
  {
    'id': 473,
    'name': 'Передача, розподіл електроенергії',
    'slug': 'power-transmission-and-distribution',
  },
  {
    'id': 394,
    'name': 'Перекладацька діяльність',
    'slug': 'translation-interpreting',
  },
  {
    'id': 618,
    'name': 'Переробка газу',
    'slug': 'gas-processing',
  },
  {
    'id': 554,
    'name': 'Пиво (виробництво)',
    'slug': 'beer-production',
  },
  {
    'id': 3,
    'name': 'Підбір і навчання персоналу',
    'slug': 'recruiting-and-training',
  },
  {
    'id': 445,
    'name': 'Підвищення кваліфікації, перекваліфікація',
    'slug': 'professional-development-retraining',
  },
  {
    'id': 615,
    'name': 'ПММ, паливо (просування, оптова торгівля)',
    'slug': 'fuels-and-lubricants-promotion-wholesale',
  },
  {
    'id': 616,
    'name': 'ПММ, паливо (роздрібна торгівля)',
    'slug': 'fuels-and-lubricants-retail',
  },
  {
    'id': 18,
    'name': 'Побутова техніка / електроніка',
    'slug': 'household-appliances-electronics',
  },
  {
    'id': 478,
    'name': 'Побутова техніка, електроніка, кліматичне обладнання (виробництво)',
    'slug': 'household-appliances-electronics-climate-control-equipment-manufacturing',
  },
  {
    'id': 479,
    'name': 'Побутова техніка, електроніка, кліматичне обладнання (монтаж, сервіс, ремонт)',
    'slug': 'household-appliances-electronics-climate-control-equipment-assembly-maintenance-repair',
  },
  {
    'id': 480,
    'name': 'Побутова техніка, електроніка, кліматичне обладнання (просування, оптова торгівля)',
    'slug': 'household-appliances-electronics-climate-control-equipment-promotion-wholesale',
  },
  {
    'id': 589,
    'name': 'Побутова хімія, парфумерія, косметика (виробництво)',
    'slug': 'household-cleaning-products-fragrance-cosmetics-manufacturing',
  },
  {
    'id': 590,
    'name': 'Побутова хімія, парфумерія, косметика (просування, оптова торгівля)',
    'slug': 'household-cleaning-products-fragrance-cosmetics-promotion-wholesale',
  },
  {
    'id': 666,
    'name': 'Послуги агенцій нерухомості',
    'slug': 'agent-services-in-real-estate',
  },
  {
    'id': 44,
    'name': 'Послуги для бізнесу',
    'slug': 'business-services',
  },
  {
    'id': 49,
    'name': 'Послуги для населення',
    'slug': 'public-services',
  },
  {
    'id': 642,
    'name': 'Послуги з ведення бухгалтерського та податкового обліку, розрахунок заробітної плати',
    'slug': 'accounting-and-tax-accounting-services-payroll-preparation',
  },
  {
    'id': 396,
    'name': 'Послуги з організації поїздок і бронювання',
    'slug': 'travel-logistics-and-booking-services',
  },
  {
    'id': 605,
    'name': 'Посуд, світло, товари для дому (виробництво)',
    'slug': 'dishes-lighting-household-products-manufacturing',
  },
  {
    'id': 606,
    'name': 'Посуд, світло, товари для дому (просування, оптова торгівля)',
    'slug': 'dishes-lighting-household-products-promotion-wholesale',
  },
  {
    'id': 458,
    'name': 'Поширення мультимедіа та друкованої продукції',
    'slug': 'distribution-of-multimedia-and-printed-material',
  },
  {
    'id': 454,
    'name': 'Поширення телепрограм, кіно (кабельне телебачення)',
    'slug': 'tv-show-film-distribution-cable-tv',
  },
  {
    'id': 407,
    'name': 'Пошиття, ремонт одягу та взуття',
    'slug': 'tailoring-mending-clothing-and-footwear',
  },
  {
    'id': 26,
    'name': 'Приладобудування / радіоелектроніка',
    'slug': 'tool-engineering-radio-and-electronics',
  },
  {
    'id': 27,
    'name': 'Продукти харчування',
    'slug': 'food-products',
  },
  {
    'id': 429,
    'name': 'Продукція авіаційної, аерокосмічної, гелікоптерної промисловості (монтаж, сервіс, ремонт)',
    'slug': 'aviation-airspace-helicopter-industry-products-assembly-maintenance-repair',
  },
  {
    'id': 430,
    'name': 'Продукція авіаційної, аерокосмічної, гелікоптерної промисловості (просування, оптова торгівля)',
    'slug': 'aviation-airspace-helicopter-industry-products-promotion-wholesale',
  },
  {
    'id': 621,
    'name': 'Продукція деревообробки (просування, оптова торгівля)',
    'slug': 'timber-industry-products-promotion-wholesale',
  },
  {
    'id': 436,
    'name': 'Продукція залізничного машинобудування, вагонобудування (монтаж, сервіс, ремонт)',
    'slug': 'railway-engineering-car-building-products-assembly-maintenance-repair',
  },
  {
    'id': 435,
    'name': 'Продукція залізничного машинобудування, вагонобудування (просування, оптова торгівля)',
    'slug': 'railway-engineering-car-building-products-promotion-wholesale',
  },
  {
    'id': 636,
    'name': 'Продукція кольорової металургії (просування, оптова торгівля)',
    'slug': 'non-ferrous-metallurgy-products-promotion-wholesale',
  },
  {
    'id': 439,
    'name': 'Продукція суднобудування (просування, оптова торгівля)',
    'slug': 'shipbuilding-products-promotion-wholesale',
  },
  {
    'id': 634,
    'name': 'Продукція чорної металургії (просування, оптова торгівля)',
    'slug': 'ferrous-metallurgy-products-promotion-wholesale',
  },
  {
    'id': 457,
    'name': 'Продюсерський центр',
    'slug': 'production-center',
  },
  {
    'id': 388,
    'name': 'Промислове обладнання, верстати та комплектуючі',
    'slug': 'industrial-equipment-machine-tools-and-components',
  },
  {
    'id': 481,
    'name': 'Промислове, побутове електрообладнання та електротехніка (виробництво)',
    'slug': 'industrial-domestic-electrical-appliances-and-electronics-manufacturing',
  },
  {
    'id': 482,
    'name': 'Промислове, побутове електрообладнання та електротехніка (монтаж, сервіс, ремонт)',
    'slug': 'industrial-domestic-electrical-appliances-and-electronics-assembly-maintenance-repair',
  },
  {
    'id': 483,
    'name': 'Промислове, побутове електрообладнання та електротехніка (просування, оптова торгівля)',
    'slug': 'industrial-domestic-electrical-appliances-and-electronics-promotion-wholesale',
  },
  {
    'id': 629,
    'name': 'Професійна, підприємницька організація',
    'slug': 'professional-entrepreneurial-organization',
  },
  {
    'id': 630,
    'name': 'Релігійна організація',
    'slug': 'religious-organization',
  },
  {
    'id': 672,
    'name': 'Ремонт будівель і споруд',
    'slug': 'repairs-of-buildings-and-constructions',
  },
  {
    'id': 528,
    'name': 'Ресторан, громадське харчування, фаст-фуд',
    'slug': 'restaurant-food-service-industry-fast-food',
  },
  {
    'id': 576,
    'name': 'Риба й морепродукти (виробництво)',
    'slug': 'fish-and-seafood-production',
  },
  {
    'id': 577,
    'name': 'Риба й морепродукти (просування, оптова торгівля)',
    'slug': 'fish-and-seafood-promotion-wholesale',
  },
  {
    'id': 532,
    'name': 'Рибальство, рибництво',
    'slug': 'fishing-fish-farming',
  },
  {
    'id': 408,
    'name': 'Ритуальні послуги',
    'slug': 'funeral-services',
  },
  {
    'id': 518,
    'name': 'Роздрібна мережа (DIY і товари для дому)',
    'slug': 'retail-chain-diy-and-household-products',
  },
  {
    'id': 512,
    'name': 'Роздрібна мережа (drogerie, товари повсякденного попиту)',
    'slug': 'retail-chain-drugstore-goods-fmcg',
  },
  {
    'id': 521,
    'name': 'Роздрібна мережа (електроніка, побутова техніка)',
    'slug': 'retail-chain-electronics-household-appliances',
  },
  {
    'id': 511,
    'name': 'Роздрібна мережа (книги, іграшки, подарунки, годинники тощо)',
    'slug': 'retail-chain-books-toys-gifts-watches-etc',
  },
  {
    'id': 513,
    'name': 'Роздрібна мережа (меблі)',
    'slug': 'retail-chain-furniture',
  },
  {
    'id': 519,
    'name': 'Роздрібна мережа (мобільний ретейл)',
    'slug': 'retail-chain-mobile-retail',
  },
  {
    'id': 515,
    'name': 'Роздрібна мережа (одяг, взуття, аксесуари)',
    'slug': 'retail-chain-clothing-footwear-accessories',
  },
  {
    'id': 516,
    'name': 'Роздрібна мережа (парфумерія, косметика)',
    'slug': 'retail-chain-perfumery-cosmetics',
  },
  {
    'id': 517,
    'name': 'Роздрібна мережа (продукти)',
    'slug': 'retail-chain-food',
  },
  {
    'id': 520,
    'name': 'Роздрібна мережа (спортивні товари)',
    'slug': 'retail-chain-sports-goods',
  },
  {
    'id': 514,
    'name': 'Роздрібна мережа (товари для дітей)',
    'slug': 'retail-chain-children-s-products',
  },
  {
    'id': 522,
    'name': 'Роздрібна мережа (ювелірні вироби)',
    'slug': 'retail-chain-jewelry',
  },
  {
    'id': 41,
    'name': 'Роздрібна торгівля',
    'slug': 'retail',
  },
  {
    'id': 544,
    'name': 'Роздрібна торгівля автомобілями (дилерський центр)',
    'slug': 'car-retail-dealer-center',
  },
  {
    'id': 540,
    'name': 'Розробка програмного забезпечення',
    'slug': 'software-development',
  },
  {
    'id': 409,
    'name': 'Салони краси',
    'slug': 'beauty-salons',
  },
  {
    'id': 597,
    'name': 'Сантехніка (виробництво)',
    'slug': 'plumbing-manufacturing',
  },
  {
    'id': 598,
    'name': 'Сантехніка (просування, оптова торгівля)',
    'slug': 'plumbing-promotion-wholesale',
  },
  {
    'id': 584,
    'name': 'Свіжі овочі, фрукти (просування, оптова торгівля)',
    'slug': 'fresh-vegetables-and-fruit-promotion-wholesale',
  },
  {
    'id': 539,
    'name': 'Системна інтеграція, автоматизації технологічних і бізнес-процесів підприємства, ІТ-консалтинг',
    'slug': 'system-integration-technological-and-business-processes-automation-it-consulting',
  },
  {
    'id': 29,
    'name': 'Сільське господарство',
    'slug': 'agriculture',
  },
  {
    'id': 533,
    'name': 'Сільськогосподарська продукція (просування, оптова торгівля)',
    'slug': 'agricultural-products-promotion-wholesale',
  },
  {
    'id': 33,
    'name': 'Складне машинобудування',
    'slug': 'heavy-engineering',
  },
  {
    'id': 466,
    'name': 'Складські послуги',
    'slug': 'warehouse-services',
  },
  {
    'id': 673,
    'name': 'Слабкострумові мережі (монтаж, сервіс, ремонт)',
    'slug': 'low-voltage-networks-assembly-maintenance-repair',
  },
  {
    'id': 580,
    'name': 'Снеки (виробництво)',
    'slug': 'snacks-manufacturing',
  },
  {
    'id': 581,
    'name': 'Снеки (просування, оптова торгівля)',
    'slug': 'snacks-promotion-wholesale',
  },
  {
    'id': 30,
    'name': 'Спорт / Спортивні товари',
    'slug': 'sports-sports-products',
  },
  {
    'id': 631,
    'name': 'Спортивна федерація',
    'slug': 'sports-federation',
  },
  {
    'id': 450,
    'name': 'Спортивне навчання',
    'slug': 'teaching-sports',
  },
  {
    'id': 410,
    'name': 'Спортивні та фітнес-клуби',
    'slug': 'sports-and-fitness-clubs',
  },
  {
    'id': 601,
    'name': 'Спортивні товари та обладнання (виробництво)',
    'slug': 'sporting-goods-and-equipment-manufacturing',
  },
  {
    'id': 602,
    'name': 'Спортивні товари та обладнання (просування, оптова торгівля)',
    'slug': 'sporting-goods-and-equipment-promotion-wholesale',
  },
  {
    'id': 622,
    'name': 'Столярно-будівельні вироби (виробництво)',
    'slug': 'woodwork-products-for-construction-manufacturing',
  },
  {
    'id': 623,
    'name': 'Столярно-будівельні вироби (просування, оптова торгівля)',
    'slug': 'woodwork-products-for-construction-promotion-wholesale',
  },
  {
    'id': 4,
    'name': 'Страхування',
    'slug': 'insurance',
  },
  {
    'id': 646,
    'name': 'Страхування, перестрахування',
    'slug': 'insurance-reinsurance',
  },
  {
    'id': 437,
    'name': 'Суднобудування',
    'slug': 'shipbuilding',
  },
  {
    'id': 438,
    'name': 'Судноремонт',
    'slug': 'ship-repair',
  },
  {
    'id': 402,
    'name': 'Супутниковий зв\'язок',
    'slug': 'satellite-communications',
  },
  {
    'id': 411,
    'name': 'Таксі',
    'slug': 'taxi',
  },
  {
    'id': 456,
    'name': 'Теле- й радіомовлення',
    'slug': 'television-and-radio-broadcasting',
  },
  {
    'id': 9,
    'name': 'Телекомунікації, зв\'язок',
    'slug': 'telecommunications-communications',
  },
  {
    'id': 471,
    'name': 'Теплоенергетика (генерація електроенергії й тепла, ТЕС)',
    'slug': 'thermal-engineering-generation-of-power-and-heat-tpp',
  },
  {
    'id': 475,
    'name': 'Теплопостачання (ТЕЦ)',
    'slug': 'heat-supply-tpp',
  },
  {
    'id': 548,
    'name': 'Технічне обслуговування, ремонт автомобілів',
    'slug': 'maintenance-repairs-of-automobiles',
  },
  {
    'id': 31,
    'name': 'Товари для дітей',
    'slug': 'products-for-children',
  },
  {
    'id': 607,
    'name': 'Товари для дітей (виробництво)',
    'slug': 'products-for-children-manufacturing',
  },
  {
    'id': 608,
    'name': 'Товари для дітей (просування, оптова торгівля)',
    'slug': 'products-for-children-promotion-wholesale',
  },
  {
    'id': 42,
    'name': 'Товари народного споживання (нехарчові)',
    'slug': 'fmcg-non-edible',
  },
  {
    'id': 465,
    'name': 'Транспортно-логістичні комплекси, порти (повітряний, водний, залізничний)',
    'slug': 'transport-and-logistics-systems-ports-air-water-railway',
  },
  {
    'id': 619,
    'name': 'Транспортування, зберігання газу',
    'slug': 'gas-transportation-storage',
  },
  {
    'id': 613,
    'name': 'Транспортування, зберігання нафти',
    'slug': 'oil-transportation-storage',
  },
  {
    'id': 446,
    'name': 'Тренінгові компанії',
    'slug': 'training-companies',
  },
  {
    'id': 32,
    'name': 'Туризм / Готелі / Ресторани',
    'slug': 'tourism-hotels-restaurants',
  },
  {
    'id': 412,
    'name': 'Туристичні компанії',
    'slug': 'travel-companies',
  },
  {
    'id': 603,
    'name': 'Тютюн (виробництво)',
    'slug': 'tobacco-production',
  },
  {
    'id': 604,
    'name': 'Тютюн (просування, оптова торгівля)',
    'slug': 'tobacco-promotion-wholesale',
  },
  {
    'id': 389,
    'name': 'Управління багатопрофільними активами',
    'slug': 'multiprofile-asset-management',
  },
  {
    'id': 664,
    'name': 'Управління та експлуатація нерухомості',
    'slug': 'real-estate-management-and-use',
  },
  {
    'id': 682,
    'name': 'Установа соц.допомоги й захисту',
    'slug': 'institute-of-social-assistance-and-protection',
  },
  {
    'id': 505,
    'name': 'Устаткування для деревообробки, заготівлі лісу, целюлозно-паперової промисловості (виробництво)',
    'slug': 'equipment-for-timber-industry-logging-cellulose-and-paper-industry-manufacturing',
  },
  {
    'id': 506,
    'name': 'Устаткування для деревообробки, заготівлі лісу, целюлозно-паперової промисловості (монтаж, сервіс, ремонт)',
    'slug': 'equipment-for-timber-industry-logging-cellulose-and-paper-industry-assembly-maintenance-repair',
  },
  {
    'id': 507,
    'name': 'Устаткування для деревообробки, заготівлі лісу, целюлозно-паперової промисловості (просування, оптова торгівля)',
    'slug': 'equipment-for-timber-industry-logging-cellulose-and-paper-industry-promotion-wholesale',
  },
  {
    'id': 490,
    'name': 'Устаткування для ресторанів, готелів, кейтерингу, роздрібної торгівлі (виробництво)',
    'slug': 'restaurant-hotel-catering-and-retail-equipment-manufacturing',
  },
  {
    'id': 491,
    'name': 'Устаткування для ресторанів, готелів, кейтерингу, роздрібної торгівлі (монтаж, сервіс, ремонт)',
    'slug': 'restaurant-hotel-catering-and-retail-equipment-assembly-maintenance-repair',
  },
  {
    'id': 492,
    'name': 'Устаткування для ресторанів, готелів, кейтерингу, роздрібної торгівлі (просування, оптова торгівля)',
    'slug': 'restaurant-hotel-catering-and-retail-equipment-promotion-wholesale',
  },
  {
    'id': 493,
    'name': 'Устаткування для харчової промисловості та сільського господарства, пакувальне обладнання (виробництво)',
    'slug': 'food-industry-and-agriculture-equipment-packaging-equipment-manufacturing',
  },
  {
    'id': 494,
    'name': 'Устаткування для харчової промисловості та сільського господарства, пакувальне обладнання (монтаж, сервіс, ремонт)',
    'slug': 'food-industry-and-agriculture-equipment-packaging-equipment-assembly-maintenance-repair',
  },
  {
    'id': 495,
    'name': 'Устаткування для харчової промисловості та сільського господарства, пакувальне обладнання (просування, оптова торгівля)',
    'slug': 'food-industry-and-agriculture-equipment-packaging-equipment-promotion-wholesale',
  },
  {
    'id': 496,
    'name': 'Устаткування й верстати для галузей легкої промисловості (виробництво)',
    'slug': 'equipment-and-machines-for-consumer-industries-manufacturing',
  },
  {
    'id': 497,
    'name': 'Устаткування й верстати для галузей легкої промисловості (монтаж, сервіс, ремонт)',
    'slug': 'equipment-and-machine-tools-for-light-industry-installation-service-repair',
  },
  {
    'id': 498,
    'name': 'Устаткування й верстати для галузей легкої промисловості (просування, оптова торгівля)',
    'slug': 'equipment-and-machines-for-consumer-industries-promotion-wholesale',
  },
  {
    'id': 499,
    'name': 'Устаткування й верстати для добувної, енергетичної, нафтогазової та хімічної галузі (виробництво)',
    'slug': 'equipment-and-machines-for-mining-energy-oil-and-gas-and-chemical-industries-manufacturing',
  },
  {
    'id': 500,
    'name': 'Устаткування й верстати для добувної, енергетичної, нафтогазової та хімічної галузі (монтаж, сервіс, ремонт)',
    'slug': 'equipment-and-machines-for-mining-energy-oil-and-gas-and-chemical-industries-assembly-maintenance-repair',
  },
  {
    'id': 501,
    'name': 'Устаткування й верстати для добувної, енергетичної, нафтогазової та хімічної галузі (просування, оптова торгівля)',
    'slug': 'equipment-and-machines-for-mining-energy-oil-and-gas-and-chemical-industries-promotion-wholesale',
  },
  {
    'id': 502,
    'name': 'Устаткування й верстати для металургії та металообробки (виробництво)',
    'slug': 'equipment-and-machines-for-metal-industry-and-metal-processing-manufacturing',
  },
  {
    'id': 503,
    'name': 'Устаткування й верстати для металургії та металообробки (монтаж, сервіс, ремонт)',
    'slug': 'equipment-and-machines-for-metal-industry-and-metal-processing-assembly-maintenance-repair',
  },
  {
    'id': 504,
    'name': 'Устаткування й верстати для металургії та металообробки (просування, оптова торгівля)',
    'slug': 'equipment-and-machines-for-metal-industry-and-metal-processing-promotion-wholesale',
  },
  {
    'id': 674,
    'name': 'Утилізація побутових відходів',
    'slug': 'household-waste-recycling',
  },
  {
    'id': 649,
    'name': 'Факторингові компанії',
    'slug': 'factoring-companies',
  },
  {
    'id': 684,
    'name': 'Фармацевтична продукція (виробництво)',
    'slug': 'pharmaceutical-products-production',
  },
  {
    'id': 683,
    'name': 'Фармацевтична продукція (просування, оптова торгівля)',
    'slug': 'pharmaceutical-products-promotion-wholesale',
  },
  {
    'id': 400,
    'name': 'Фіксований зв\'язок',
    'slug': 'fixed-communications',
  },
  {
    'id': 43,
    'name': 'Фінансовий сектор',
    'slug': 'financial-sector',
  },
  {
    'id': 549,
    'name': 'Фінансові послуги (кептивні банки та лізингові компанії)',
    'slug': 'financial-services-captive-banks-and-leasing-companies',
  },
  {
    'id': 650,
    'name': 'Фінансово-кредитне посередництво (біржа, брокерська діяльність, випуск та обслуговування карток, оцінювання ризиків, обмінні пункти, агенції з кредитування, інкасація, ломбард, платіжні системи)', // eslint-disable-line
    'slug': 'financial-and-credit-brokering-stock-exchange-brokerage-activity-card-issuing-and-servicing-risk-assessment-currency-exchange-points-crediting-agencies-cash-collectors-pawnshop-payment-systems', // eslint-disable-line
  },
  {
    'id': 632,
    'name': 'Фонд, грантодавець',
    'slug': 'fund-donor',
  },
  {
    'id': 413,
    'name': 'Фото- й відеопослуги',
    'slug': 'photo-and-video-services',
  },
  {
    'id': 574,
    'name': 'Харчові концентрати (виробництво)',
    'slug': 'food-concentrates-production',
  },
  {
    'id': 575,
    'name': 'Харчові концентрати (просування, оптова торгівля)',
    'slug': 'food-concentrates-promotion-wholesale',
  },
  {
    'id': 34,
    'name': 'Хімічне виробництво, добрива',
    'slug': 'chemical-production-fertilizers',
  },
  {
    'id': 414,
    'name': 'Хімчистка',
    'slug': 'dry-cleaning',
  },
  {
    'id': 585,
    'name': 'Хлібобулочні вироби (виробництво)',
    'slug': 'bakery-products-production',
  },
  {
    'id': 586,
    'name': 'Хлібобулочні вироби (просування, оптова торгівля)',
    'slug': 'bakery-products-promotion-wholesale',
  },
  {
    'id': 625,
    'name': 'Целюлозно-паперова продукція (просування, оптова торгівля)',
    'slug': 'cellulose-and-paper-products-promotion-wholesale',
  },
  {
    'id': 624,
    'name': 'Целюлозно-паперове виробництво',
    'slug': 'cellulose-and-paper-production',
  },
  {
    'id': 415,
    'name': 'Центри розваг',
    'slug': 'entertainment-centers',
  },
  {
    'id': 582,
    'name': 'Цукор (виробництво)',
    'slug': 'sugar-production',
  },
  {
    'id': 583,
    'name': 'Цукор (просування, оптова торгівля)',
    'slug': 'sugar-promotion-wholesale',
  },
  {
    'id': 587,
    'name': 'Чай, кава (виробництво)',
    'slug': 'tea-coffee-production',
  },
  {
    'id': 588,
    'name': 'Чай, кава (просування, оптова торгівля)',
    'slug': 'tea-coffee-promotion-wholesale',
  },
  {
    'id': 633,
    'name': 'Чорна металургія (виробництво чавуну, сталі, прокату)',
    'slug': 'ferrous-metallurgy-production-of-iron-steel-mill-products',
  },
  {
    'id': 443,
    'name': 'Школа, дитячий садок',
    'slug': 'school-kindergarten',
  },
  {
    'id': 35,
    'name': 'Шоу-бізнес / розваги / гральний бізнес',
    'slug': 'show-business-entertainment-gambling',
  },
  {
    'id': 609,
    'name': 'Ювелірні вироби, біжутерія (виробництво)',
    'slug': 'jewelry-fashion-jewelry-manufacturing',
  },
  {
    'id': 610,
    'name': 'Ювелірні вироби, біжутерія (просування, оптова торгівля)',
    'slug': 'jewelry-fashion-jewelry-promotion-wholesale',
  },
  {
    'id': 398,
    'name': 'Юридичне обслуговування',
    'slug': 'legal-services',
  },
  {
    'id': 6,
    'name': 'Юриспруденція',
    'slug': 'law',
  },
];

export const education_level = [
  {
    'name': 'Доктор наук',
    'value': 5,
  },
  {
    'name': 'Кандидат наук',
    'value': 4,
  },
  {
    'name': 'Магістр',
    'value': 3,
  },
  {
    'name': 'Бакалавр',
    'value': 2,
  },
  {
    'name': 'Вища',
    'value': 1,
  },
  {
    'name': 'Незакінчена вища',
    'value': 6,
  },
  {
    'name': 'Середня спеціальна',
    'value': 8,
  },
  {
    'name': 'Середня',
    'value': 7,
  },
];

export const langs = [
  {
    'id': 74,
    'name': 'Абазинська',
    'slug': 'abq',
  },
  {
    'id': 68,
    'name': 'Абхазька',
    'slug': 'ab',
  },
  {
    'id': 176,
    'name': 'Аварська',
    'slug': 'av',
  },
  {
    'id': 1,
    'name': 'Азербайджанська',
    'slug': 'az',
  },
  {
    'id': 2,
    'name': 'Албанська',
    'slug': 'sq',
  },
  {
    'id': 143,
    'name': 'Амхарська',
    'slug': 'am',
  },
  {
    'id': 57,
    'name': 'Англійська',
    'slug': 'en',
  },
  {
    'id': 3,
    'name': 'Арабська',
    'slug': 'ar',
  },
  {
    'id': 5,
    'name': 'Африкаанс',
    'slug': 'af',
  },
  {
    'id': 177,
    'name': 'Баскська',
    'slug': 'eu',
  },
  {
    'id': 6,
    'name': 'Башкирська',
    'slug': 'ba',
  },
  {
    'id': 178,
    'name': 'Бенгальська',
    'slug': 'bn',
  },
  {
    'id': 7,
    'name': 'Білоруська',
    'slug': 'be',
  },
  {
    'id': 210,
    'name': 'Бірманська',
    'slug': 'my',
  },
  {
    'id': 8,
    'name': 'Болгарська',
    'slug': 'bg',
  },
  {
    'id': 179,
    'name': 'Боснійська',
    'slug': 'bs',
  },
  {
    'id': 180,
    'name': 'Бурятська',
    'slug': 'bua',
  },
  {
    'id': 10,
    'name': 'В\'єтнамська',
    'slug': 'vi',
  },
  {
    'id': 4,
    'name': 'Вірменська',
    'slug': 'hy',
  },
  {
    'id': 11,
    'name': 'Голландська',
    'slug': 'nl',
  },
  {
    'id': 12,
    'name': 'Грецька',
    'slug': 'el',
  },
  {
    'id': 13,
    'name': 'Грузинська',
    'slug': 'ka',
  },
  {
    'id': 181,
    'name': 'Дагестанська',
    'slug': 'dag',
  },
  {
    'id': 14,
    'name': 'Данська',
    'slug': 'da',
  },
  {
    'id': 144,
    'name': 'Даргинська',
    'slug': 'dar',
  },
  {
    'id': 64,
    'name': 'Есперанто',
    'slug': 'eo',
  },
  {
    'id': 54,
    'name': 'Естонська',
    'slug': 'et',
  },
  {
    'id': 15,
    'name': 'Іврит',
    'slug': 'he',
  },
  {
    'id': 62,
    'name': 'Інгуська',
    'slug': 'inh',
  },
  {
    'id': 60,
    'name': 'Індонезійська',
    'slug': 'id',
  },
  {
    'id': 184,
    'name': 'Ірландська',
    'slug': 'ga',
  },
  {
    'id': 185,
    'name': 'Ісландська',
    'slug': 'is',
  },
  {
    'id': 16,
    'name': 'Іспанська',
    'slug': 'es',
  },
  {
    'id': 17,
    'name': 'Італійська',
    'slug': 'it',
  },
  {
    'id': 70,
    'name': 'Кабардино-черкеська',
    'slug': 'kbd',
  },
  {
    'id': 18,
    'name': 'Казахська',
    'slug': 'kk',
  },
  {
    'id': 71,
    'name': 'Карачаєво-балкарська',
    'slug': 'krc',
  },
  {
    'id': 186,
    'name': 'Карельська',
    'slug': 'krl',
  },
  {
    'id': 72,
    'name': 'Каталонська',
    'slug': 'ca',
  },
  {
    'id': 63,
    'name': 'Кашмірська',
    'slug': 'ks',
  },
  {
    'id': 19,
    'name': 'Киргизька',
    'slug': 'ky',
  },
  {
    'id': 20,
    'name': 'Китайська',
    'slug': 'zh',
  },
  {
    'id': 21,
    'name': 'Комі',
    'slug': 'kv',
  },
  {
    'id': 22,
    'name': 'Корейська',
    'slug': 'ko',
  },
  {
    'id': 67,
    'name': 'Креольська (Сейшельські острови)',
    'slug': 'crs',
  },
  {
    'id': 75,
    'name': 'Кумикська',
    'slug': 'kum',
  },
  {
    'id': 23,
    'name': 'Курдська',
    'slug': 'ku',
  },
  {
    'id': 66,
    'name': 'Кхмерська (Камбоджійська)',
    'slug': 'km',
  },
  {
    'id': 187,
    'name': 'Лакська',
    'slug': 'lbe',
  },
  {
    'id': 188,
    'name': 'Лаоська',
    'slug': 'lo',
  },
  {
    'id': 109,
    'name': 'Латинська',
    'slug': 'la',
  },
  {
    'id': 24,
    'name': 'Латиська',
    'slug': 'lv',
  },
  {
    'id': 189,
    'name': 'Лезгинська',
    'slug': 'lez',
  },
  {
    'id': 25,
    'name': 'Литовська',
    'slug': 'lt',
  },
  {
    'id': 26,
    'name': 'Македонська',
    'slug': 'mk',
  },
  {
    'id': 110,
    'name': 'Малайзійська',
    'slug': 'zlm',
  },
  {
    'id': 202,
    'name': 'Мансійська',
    'slug': 'mns',
  },
  {
    'id': 191,
    'name': 'Марійська',
    'slug': 'chm',
  },
  {
    'id': 28,
    'name': 'Монгольська',
    'slug': 'mn',
  },
  {
    'id': 192,
    'name': 'Непальська',
    'slug': 'ne',
  },
  {
    'id': 58,
    'name': 'Німецька',
    'slug': 'de',
  },
  {
    'id': 142,
    'name': 'Ногайська',
    'slug': 'nog',
  },
  {
    'id': 29,
    'name': 'Норвезька',
    'slug': 'no',
  },
  {
    'id': 69,
    'name': 'Осетинська',
    'slug': 'os',
  },
  {
    'id': 193,
    'name': 'Панджабі',
    'slug': 'pa',
  },
  {
    'id': 30,
    'name': 'Перська',
    'slug': 'fa',
  },
  {
    'id': 31,
    'name': 'Польська',
    'slug': 'pl',
  },
  {
    'id': 32,
    'name': 'Португальська',
    'slug': 'pt',
  },
  {
    'id': 194,
    'name': 'Пушту',
    'slug': 'ps',
  },
  {
    'id': 34,
    'name': 'Російська',
    'slug': 'ru',
  },
  {
    'id': 33,
    'name': 'Румунська',
    'slug': 'ro',
  },
  {
    'id': 35,
    'name': 'Санскрит',
    'slug': 'sa',
  },
  {
    'id': 36,
    'name': 'Сербська',
    'slug': 'sr',
  },
  {
    'id': 37,
    'name': 'Словацька',
    'slug': 'sk',
  },
  {
    'id': 38,
    'name': 'Словенська',
    'slug': 'sl',
  },
  {
    'id': 195,
    'name': 'Сомалійська',
    'slug': 'so',
  },
  {
    'id': 39,
    'name': 'Суахілі',
    'slug': 'sw',
  },
  {
    'id': 196,
    'name': 'Тагальська',
    'slug': 'tl',
  },
  {
    'id': 40,
    'name': 'Таджицька',
    'slug': 'tg',
  },
  {
    'id': 41,
    'name': 'Тайська',
    'slug': 'th',
  },
  {
    'id': 197,
    'name': 'Таліська',
    'slug': 'tly',
  },
  {
    'id': 76,
    'name': 'Тамільська',
    'slug': 'ta',
  },
  {
    'id': 42,
    'name': 'Татарська',
    'slug': 'tt',
  },
  {
    'id': 198,
    'name': 'Тибетська',
    'slug': 'bo',
  },
  {
    'id': 199,
    'name': 'Тувинська',
    'slug': 'tyv',
  },
  {
    'id': 43,
    'name': 'Турецька',
    'slug': 'tr',
  },
  {
    'id': 44,
    'name': 'Туркменська',
    'slug': 'tk',
  },
  {
    'id': 9,
    'name': 'Угорська',
    'slug': 'hu',
  },
  {
    'id': 209,
    'name': 'Удмуртський',
    'slug': 'udm',
  },
  {
    'id': 45,
    'name': 'Узбецька',
    'slug': 'uz',
  },
  {
    'id': 73,
    'name': 'Уйгурська',
    'slug': 'ug',
  },
  {
    'id': 46,
    'name': 'Українська',
    'slug': 'uk',
  },
  {
    'id': 47,
    'name': 'Урду',
    'slug': 'ur',
  },
  {
    'id': 48,
    'name': 'Фінська',
    'slug': 'fi',
  },
  {
    'id': 201,
    'name': 'Фламандська',
    'slug': 'vls',
  },
  {
    'id': 59,
    'name': 'Французька',
    'slug': 'fr',
  },
  {
    'id': 56,
    'name': 'Хінді',
    'slug': 'hi',
  },
  {
    'id': 49,
    'name': 'Хорватська',
    'slug': 'hr',
  },
  {
    'id': 51,
    'name': 'Чеська',
    'slug': 'cs',
  },
  {
    'id': 50,
    'name': 'Чеченська',
    'slug': 'ce',
  },
  {
    'id': 52,
    'name': 'Чуваська',
    'slug': 'cv',
  },
  {
    'id': 53,
    'name': 'Шведська',
    'slug': 'sv',
  },
  {
    'id': 203,
    'name': 'Якутська',
    'slug': 'sah',
  },
  {
    'id': 55,
    'name': 'Японська',
    'slug': 'ja',
  },
];

export const lang_skills = [
  {
    'id': 6,
    'name': 'A1 (початковий) або вище',
    'slug': 'A1',
  },
  {
    'id': 7,
    'name': 'A2 (елементарний) або вище',
    'slug': 'A2',
  },
  {
    'id': 8,
    'name': 'B1 (середній) або вище',
    'slug': 'B1',
  },
  {
    'id': 9,
    'name': 'B2 (вищий середній) або вище',
    'slug': 'B2',
  },
  {
    'id': 10,
    'name': 'C1 (просунутий) або вище',
    'slug': 'C1',
  },
  {
    'id': 11,
    'name': 'C2 (доскональний) або вище',
    'slug': 'C2',
  },
  {
    'id': 12,
    'name': 'L1 рідна',
    'slug': 'L1',
  },
];

export const driver_categories = [
  {
    'id': 1,
    'name': 'A1',
  },
  {
    'id': 2,
    'name': 'A',
  },
  {
    'id': 3,
    'name': 'B1',
  },
  {
    'id': 4,
    'name': 'B',
  },
  {
    'id': 5,
    'name': 'C1',
  },
  {
    'id': 6,
    'name': 'C',
  },
  {
    'id': 7,
    'name': 'D1',
  },
  {
    'id': 8,
    'name': 'D',
  },
  {
    'id': 9,
    'name': 'BE',
  },
  {
    'id': 10,
    'name': 'C1E',
  },
  {
    'id': 11,
    'name': 'CE',
  },
  {
    'id': 12,
    'name': 'D1E',
  },
  {
    'id': 13,
    'name': 'DE',
  },
  {
    'id': 14,
    'name': 'T',
  },
];
